import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Collapse,
  Drawer,
  ListItemIcon,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useLocation, useNavigate } from "react-router";
import PerfectScrollbar from "react-perfect-scrollbar";
import StyledListItemButton from "./MenuList/commons/StyledListItemButton";
import Logo from "ui-component/Logo";
import { filterMenuItems } from "utils/menufilter";

const MenuItemsCollapsible = ({ options, title, icon }) => {
  const customization = useSelector((state) => state.customization);
  const [collapseState, setCollapseState] = useState(true);
  let location = useLocation();
  const navigate = useNavigate();
  const Icon = icon;
  const itemIcon = Icon && <Icon stroke={1.5} size="1.3rem" />;
  return (
    <Box>
      <StyledListItemButton
        onClick={() => {
          setCollapseState((pr) => !pr);
        }}
        customization={customization}
        width="240px"
        sx={{
          marginBottom: "0px",
          display: "flex",
          flexDirection: "row",
          padding: "16px 16px",
          alignItems: "center",
          justifyContent: "space-between",
          columnGap: "8px",
          opacity: 1,
          "& .MuiTypography-root": {
            color: "#333333 !important",
            fontSize: "14px",
            fontWeight: 500,
          },
          "&:hover": {
            "& .MuiListItemIcon-root": {
              color: " #333333 !important",
            },
            "& .MuiTypography-root": {
              color: "#333333 !important",
            },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            columnGap: "8px",
            alignItems: "center",
          }}
        >
          <ListItemIcon sx={{ minWidth: "unset" }}>{itemIcon}</ListItemIcon>
          <Typography
            sx={{
              fontFamily: customization?.fontFamily,
              width: "auto",
              color: "#333333",
            }}
          >
            {title}
          </Typography>
        </Box>

        <KeyboardArrowDownRoundedIcon
          fontSize="small"
          sx={{
            transform: `rotate(${collapseState ? "180deg" : "360deg"})`,
            alignItems: "end",
          }}
        />
      </StyledListItemButton>

      <Collapse in={collapseState}>
        {options?.map((menuItems, index) => {
          return (
            <StyledListItemButton
              key={index}
              selected={location.pathname === menuItems?.url}
              onClick={() => navigate(menuItems?.url)}
              customization={customization}
              width="240px"
              sx={{
                marginBottom: "8px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: "43px",
                columnGap: "8px",
                height: "48px",
              }}
            >
              {menuItems?.icon}
              <Typography
                sx={{
                  fontFamily: customization?.fontFamily,
                  display: "inline-block",
                  color: "#333333",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {menuItems?.title}
              </Typography>
            </StyledListItemButton>
          );
        })}
      </Collapse>
    </Box>
  );
};

const MobileDrawer = ({ drawerOpen, drawerToggle }) => {
  const { authState } = useSelector((state) => state.auth);
  const theme = useTheme();
  const maxWidth1199 = useMediaQuery("(max-width:1199px)");

  const container =
    window !== undefined ? () => window.document.body : undefined;

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { md: 0 },
        display: maxWidth1199 ? "block" : "none",
      }}
      aria-label="mailbox folders"
    >
      <Drawer
        container={container}
        variant={"temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          position: "relative",
          display: maxWidth1199 ? "block" : "none",
          zIndex: drawerOpen ? 10001 : 1,
          "& .MuiDrawer-root": {
            position: "unset",
            zIndex: 1,
            background: "red",
          },
          "& .MuiDrawer-paper": {
            width: "272px",
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: "none",
            [theme.breakpoints.up("md")]: {
              top: maxWidth1199 ? 0 : "80px",
            },
          },
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        <PerfectScrollbar component="div">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              rowGap: "24px",
              paddingBottom: "30px",
            }}
          >
            <Box
              sx={{
                height: "50px",
                mt: "24px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Logo />
            </Box>
            {filterMenuItems(authState)?.map((tab, index) => {
              return (
                <MenuItemsCollapsible
                  key={`tabs-${index}`}
                  options={tab?.children}
                  title={tab?.title}
                  icon={tab?.icon}
                />
              );
            })}
          </Box>
        </PerfectScrollbar>
      </Drawer>
    </Box>
  );
};

export default MobileDrawer;
